import Content from "uxp-documentation/src/pages/uxp-api/reference-spectrum/User Interface/sp-dropdown";
import * as React from 'react';
export default {
  Content,
  React
};